export const executorCategories = [
  {
    label: 'Манипуляторы до 15т',
    singleLabel: 'Манипулятор до 15т',
    value: 'manipulator-15',
  },
  {
    label: 'Грузовики до 10т',
    singleLabel: 'Грузовик до 10т',
    value: 'truck-10',
  },
  {
    label: 'Самосвалы',
    singleLabel: 'Самосвал',
    value: 'dump-truck',
  },
  {
    label: 'Экскаваторы',
    singleLabel: 'Экскаватор',
    value: 'excavator',
  },
  {
    label: 'Большегрузы',
    singleLabel: 'Большегруз',
    value: 'heavy-truck',
  },
  {
    label: 'Краны 25-100т',
    singleLabel: 'Кран 25-100т',
    value: 'crane-25-100',
  },
  {
    label: 'Погрузчики',
    singleLabel: 'Погрузчик',
    value: 'loader',
  },
];
